import React, { Component } from "react";
import Container from "../../common/application_container";
import { withRouter } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { getUser } from "../../../actions/session";
import Axios from "axios";
import { CARRIER_STATS_PER_DAY } from "../../../config/rest_endpoints";
import { Notifications } from "../../common/notification";
import CustomLoader from "../../common/loader";

// datetime picker imports
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from "moment";

class CarrierPerDay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      User: getUser(),
      data: [],
      id: this.props.match.params.id,
      name: this.props.match.params.name,
      startDate: moment(new Date()),
      endDate: moment(new Date()),
      // startDate: setHours(setMinutes(setSeconds(new Date(), 0), 0), 0),
      // endDate: setHours(setMinutes(setSeconds(new Date(), 59), 59), 23),
      isGetting: false,
      isBtnSpin:false,
      isDownLoadSpin: false
    };
    this.getReportOnSelectDate = this.getReportOnSelectDate.bind(this);
    this.handleDate = this.handleDate.bind(this);
  }

  handleDate(date, value) {
    if (value == "start") {
      this.setState({ startDate: date }, () => {});
    } else {
      this.setState({ endDate: date }, () => {});
    }
  }

  getReportOnSelectDate(data) {
    const { User, startDate, endDate, selectedAccount, id } = this.state;
    console.log("startDate",startDate);
    var payload = {
      startDate: moment(startDate).format('MM/DD/YYYY, h:mm:ss A'),
      endDate: moment(endDate).format('MM/DD/YYYY, h:mm:ss A'),
    };
    console.log(`payload`, payload);
    this.setState({ isGetting: true , isBtnSpin: true, isDownLoadSpin:false });
    var headers = { Authorization: "Bearer " + User.token };
    if (data === "download") {
      this.setState({ isGetting: false , isBtnSpin: false, isDownLoadSpin:true });
      Axios.post(`${CARRIER_STATS_PER_DAY}/${id}?download=true`, payload, {
        headers,
      })
        .then((res) => {
          if (res) {
            var resp = res.data;
            console.log("resp", resp);
            const getFileName = res.headers["content-disposition"];
            const settingFileName = getFileName.replace(
              "attachment; filename=",
              ""
            );
            const url = window.URL.createObjectURL(new Blob([resp]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${settingFileName}.csv`);
            document.body.appendChild(link);
            Notifications.notify(
              "File is been downloading...",
              "Downloading",
              "success"
            );
            link.click();
            this.setState({ isGetting: false, isBtnSpin:false, isDownLoadSpin:false });
          }
        })
        .catch((err) => {
          const alert = err.response;
          if (alert.data.message === "invalid or expired jwt") {
            localStorage.removeItem("user");
            this.setState({ isLoginURL: true });
            Notifications.notify(alert.data.message, "Token Expire", "error");
          }
          Notifications.notify(alert.data.message, "Failed", "error");
          this.setState({
            isGetting: false,
            isBtnSpin: false,
            isDownLoadSpin: false
          });
        });
    } else {
      Axios.post(`${CARRIER_STATS_PER_DAY}/${id}`, payload, { headers })
        .then((res) => {
          if (res) {
            var resp = res.data.data;
            this.setState({
              data: resp,
              isGetting: false,
              isBtnSpin: false,
              isDownLoadSpin: false
            });
          }
        })
        .catch((err) => {
          const alert = err.response;
          if (alert.data.message === "invalid or expired jwt") {
            localStorage.removeItem("user");
            this.setState({ isLoginURL: true });
            Notifications.notify(alert.data.message, "Token Expire", "error");
          }
          Notifications.notify(alert.data.message, "Failed", "error");
          this.setState({
            isGetting: false,
          });
        });
    }
  }

  accountStatsReportTable() {
    const { data, isGetting } = this.state;
    if (data.length === 0 || data === null) {
      return (
        <div className="ml-3 mt-3">
          <div
            className="dataTables_info"
            id="DataTables_Table_0_info"
            role="status"
            aria-live="polite"
          >
            Showing 0 of 0 entries
          </div>
          <div
            className="dataTables_paginate paging_simple_numbers"
            id="DataTables_Table_0_paginate"
          ></div>
        </div>
      );
    } else {
      return data.map((stats, idx) => {
        return (
          <tr key={idx} className="right_align">
            <td className="table-data">{stats.createDate}</td>
            <td className="table-data">{stats.revenue.toFixed(4)}</td>
            <td className="table-data">{stats.cost.toFixed(4)}</td>
            <td className="table-data">{stats.profit}</td>
            <td className="table-data">{stats.minutes}</td>
            <td className="table-data">{stats.ACD}</td>
            <td className="table-data">{stats.SDP}</td>
            <td className="table-data">{stats.ASR}</td>
            <td className="table-data">{stats.completed}</td>
            <td className="table-data">{stats.outCalls}</td>
            <td className="table-data">{stats.attempts_4xx}</td>
            <td className="table-data">{stats.attempts_5xx}</td>
            <td className="table-data">{stats.attempts_6xx}</td>
            <td className="table-data">{stats.sdCount}</td>
          </tr>
        );
      });
    }
  }

  render() {
    const { name, startDate, endDate, isGetting, data, isBtnSpin, isDownLoadSpin } = this.state;
    return (
      <Container
        title={name.toUpperCase() + " Reports"}
        title1="Information"
        icon="icon-lan"
      >
        <div>
          <div style={{border:'none',borderRadius:'5px',boxShadow:'0 0 20px rgba(0,0,0,.08)'}} className="card card-body">
            <div className="card-header header-elements-inline p-0 py-1 mb-2">
                <h5 style={{fontWeight:'700',fontSize:'24px'}} className="card-title"></h5>
                <div className="header-elements">
                </div>
            </div>
            {/* heading */}
              <div class="d-flex justify-content-between flex-wrap bg-light rounded border p-0 mb-2 ">
                <div class=" py-2 px-3 mb-1">
                  <div class="">
                    <label className="fs-14">
                      Start Date
                      <span className="text-muted "> UTC Time-zone</span>{" "}
                    </label>
                    <div class="input-group">
                    <DateRangePicker
                showWeekNumbers
                    onCallback={(date) => this.handleDate(date, "start")}
                    initialSettings={{
                      singleDatePicker: true,
                      // timePicker: false,
                      showDropdowns: true,
                      startDate: moment(startDate),
                      locale: {
                        format: 'MMMM/DD/YYYY',
                      },
                    }}
                >
                  <input  type="text" className="form-control" style={{ minWidth: '300px' }} />
                </DateRangePicker>
                      {/* <DatePicker
                        selected={startDate}
                        onChange={(date) => this.handleDate(date, "start")}
                        className="reporting-theme-date w-100"
                        maxDate={new Date()}
                        includeTimes={[
                          setHours(setMinutes(setSeconds(new Date(), 0), 0), 0),
                        ]}
                        showTimeSelect
                        timeIntervals={15}
                        dateFormat="MMMM d, yyyy h:mm:ss aa"
                        isClearable
                        placeholderText="Add date"
                      ></DatePicker> */}
                    </div>
                  </div>
                </div>
                <div class=" py-2 px-3 mb-1">
                  <div class="">
                    <label className="fs-14">
                      End Date
                      <span className="text-muted "> UTC Time-zone</span>{" "}
                    </label>
                    <div class="input-group">
                    <DateRangePicker
                    onCallback={(date) => this.handleDate(date, "end")}
                    initialSettings={{
                      singleDatePicker: true,
                      // timePicker: false,
                      showDropdowns: true,
                      startDate: moment(endDate),
                      locale: {
                        format: 'MMMM/DD/YYYY',
                      },
                    }}
                >
                  <input type="text" className="form-control" style={{ minWidth: '300px' }} />
                </DateRangePicker>
                      {/* <DatePicker
                        name="end"
                        selected={endDate}
                        onChange={(date) => this.handleDate(date, "end")}
                        className="reporting-theme-date w-100"
                        maxDate={new Date()}
                        includeTimes={[
                          setHours(
                            setMinutes(setSeconds(new Date(), 59), 59),
                            11
                          ),
                        ]}
                        showTimeSelect
                        timeIntervals={15}
                        dateFormat="MMMM d, yyyy h:mm:ss aa"
                        isClearable
                        placeholderText="Add date"
                      ></DatePicker> */}
                    </div>
                  </div>
                </div>
                <div class=" py-2 px-3 mb-1">
                  <div
                    className=""
                    style={{ marginLeft: "", marginTop: "2.2em" }}
                  >
                    <button
                      type="submit"
                      className="btn btn-success btn-sm main-button "
                      onClick={this.getReportOnSelectDate}
                    >
                      Search <i class={`${isBtnSpin ? 'icon-spinner4 spinner' : 'icon-arrow-right8'} ml-2`}></i>
                    </button>
                  </div>
                </div>
              </div>
            {/* row */}
            <div className="card-header header-elements-inline p-0 py-1 mb-2">
                <h5 style={{fontWeight:'700',fontSize:'24px'}} className="card-title"></h5>
                <div className="header-elements">
                <button
                      type="submit"
                      className="btn btn-success btn-sm main-button"
                      onClick={this.getReportOnSelectDate.bind(
                        this,
                        "download"
                      )}
                    >
                      Download CSV <i class={`${isDownLoadSpin ? 'icon-spinner4 spinner' : 'icon-download7'} ml-2`}></i>
                    </button>
                </div>
            </div>
            <div className="">
              <div
                className="table-responsive"
                style={{
                  overflowX: "auto",
                  overflowY: "auto",
                  maxHeight: "56em",
                }}
              >
                <table className="table-style table table-striped dataTable no-footer">
                  <thead>
                    <tr
                      className="stickeyHeader table-heading-style"
                      style={{ zIndex: 0 }}
                    >
                      <th>Create Date</th>
                      <th>Revenue</th>
                      <th>Cost</th>
                      <th>Profit</th>
                      <th>Minutes</th>
                      <th>ACD</th>
                      <th>SDP</th>
                      <th>ASR</th>
                      <th>Completed</th>
                      <th>Out Calls</th>
                      <th>4XX Calls</th>
                      <th>5XX Calls</th>
                      <th>6XX Calls</th>
                      <th>SD Count</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isGetting ? (
                      <CustomLoader />
                    ) : (
                      this.accountStatsReportTable()
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <ReactTooltip
              type="success"
              backgroundColor="#4caf50"
              place="top"
              effect="solid"
            />
          </div>
        </div>
      </Container>
    );
  }
}
export default withRouter(CarrierPerDay);
